import { callExternalApi } from "./external-api.service";

const tlogApiServerUrl = process.env.REACT_APP_TLOG_API_SERVER_URL;

export const runScraper = async (scoresData, accessToken) => {
  const config = {
    url: `${tlogApiServerUrl}/api/scraper/scrape`,
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    data: {'scoresData': scoresData},
};

const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
};
};